import AjaxService from '@/services/ajax-service'

class AjaxInvitationService extends AjaxService {

  getInvitationHeader(code) {
    return {
      'X-INVITATION-CODE': code
    }
  }

}

export default AjaxInvitationService